import { Subject } from '../types';

export const BOARD_OPTIONS = ['AQA', 'OCR', 'Edexcel'] as const;
export type ExamBoard = typeof BOARD_OPTIONS[number];

const SUBJECT_BOARD_MAP: Record<Subject, ExamBoard[]> = {
  [Subject.Physics]: BOARD_OPTIONS,
  [Subject.Chemistry]: BOARD_OPTIONS,
  [Subject.Maths]: BOARD_OPTIONS,
  [Subject.FurtherMaths]: BOARD_OPTIONS,
  [Subject.Biology]: BOARD_OPTIONS,
  [Subject.Economics]: BOARD_OPTIONS,
  [Subject.GCSEMaths]: BOARD_OPTIONS,
  [Subject.GCSEBiology]: BOARD_OPTIONS,
  [Subject.GCSEPhysics]: BOARD_OPTIONS,
  [Subject.GCSEChemistry]: BOARD_OPTIONS,
  [Subject.GCSEHistory]: ['AQA'], // Only AQA available for now
  [Subject.General]: BOARD_OPTIONS,
};

export const getBoardsForSubject = (subject: Subject): ExamBoard[] => {
  return SUBJECT_BOARD_MAP[subject] || BOARD_OPTIONS;
};
